import PropTypes from 'prop-types';

const HeaderStylesArray = ['angle', 'swoop', 'default'];

export const HeaderStyle = PropTypes.oneOf(HeaderStylesArray);
